export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9198.1c4f8e97.jpg";